import React, { lazy, Suspense } from 'react'
import { Provider } from 'react-redux'
import { persistor, store } from './redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import logo from './assets/darklogo.png'

const AppRouter = lazy(() => import("./routes"))
const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={<div className="min-h-screen flex justify-center items-center"><img src={logo} alt='' width={250}/></div>}>
          <AppRouter />
        </Suspense>
      </PersistGate>
    </Provider>
  )
}

export default App
